module.exports = __webpack_public_path__ + "media/confetti.47c24264.mp3";